import React from 'react';
import './Elem4Next.css';


const Elem4Next = ({ onClick }) => {
  return (
    <button onClick={onClick} className="next-container">
      Next
    </button>
  );
};

export default Elem4Next;
